/**
 * Settings declarations learned at runtime (docs/policy-manifest.md): what the policy editors
 * validate and render against comes from the policy manifests the platform holds, by digest, not
 * from a copy cut with an AIOE release. The bundled copy (`settings/declarations.ts`) is the
 * last resort while no machine has reported a manifest and no release carries one. An AIOE
 * release is cut only for capability of AIOE's own, never because the workbench released.
 */
import { settingsDeclarations } from "./settingsPolicy.js";
/** A manifest's setting in the declaration shape the validator reads. */
export function declarationFromManifest(m) {
    return { type: m.type, default: m.default, ...(m.description ? { description: m.description } : {}), ...(m.enum ? { enum: m.enum } : {}), ...(m.minimum !== undefined ? { minimum: m.minimum } : {}), ...(m.maximum !== undefined ? { maximum: m.maximum } : {}) };
}
/**
 * Every setting any held manifest declares, newest build first so the newest wins a key, over the
 * bundled copy: a value a newer workbench understands is never refused because the platform's copy
 * is older.
 */
export function declarationsFromManifests(manifests, base = settingsDeclarations) {
    const out = { ...base };
    for (const m of [...manifests].reverse())
        for (const s of m.settings)
            out[s.key] = declarationFromManifest(s);
    return out;
}
//# sourceMappingURL=settingsFromManifest.js.map